import type { EntityProps } from 'Components/EntityListCard/EntityListCard.types'

import type {
  getRental_rental,
  getRental_rental_children,
} from 'Constants/graphql/queries/detail/__generated__/getRental'

import { GLOBAL_ROUTE_PATHS } from 'Portal/src/router/Router.constants'
import { composePath } from 'Portal/src/utilities/composePath/composePath.util'

const generateLink = ({
  rentalId,
  isOrganisation,
  employeeId,
  organisationId,
}: {
  rentalId: getRental_rental_children['id']
  isOrganisation: boolean
  employeeId?: string
  organisationId?: string
}): string =>
  composePath({
    isOrganisation,
    params: {
      employeeId,
      organisationId,
      rentalId,
    },
    paths: {
      employee: GLOBAL_ROUTE_PATHS.employee.rental,
      organisation: GLOBAL_ROUTE_PATHS.organisation.rental,
    },
  })

export const generateChildEntities = ({
  childRentals,
  isOrganisation,
  employeeId,
  organisationId,
}: {
  childRentals?: getRental_rental['children']
  isOrganisation: boolean
  employeeId?: string
  organisationId?: string
}): EntityProps[] => {
  if (!childRentals) {
    return []
  }

  const filteredChildren =
    childRentals.filter(
      (childRental): childRental is getRental_rental_children =>
        childRental !== null,
    ) || []

  return filteredChildren.map(childRental => ({
    content: null,
    id: childRental.id,
    imageSource: childRental?.deviceDefinition?.imageURL,
    link: generateLink({
      employeeId,
      isOrganisation,
      organisationId,
      rentalId: childRental.id,
    }),
    title: childRental?.deviceDefinition?.name || '',
  }))
}

export const generateParentEntity = ({
  parentRental,
  isOrganisation,
  employeeId,
  organisationId,
}: {
  parentRental?: getRental_rental['parent']
  isOrganisation: boolean
  employeeId?: string
  organisationId?: string
}): EntityProps[] => {
  if (!parentRental) {
    return []
  }

  return [
    {
      content: null,
      id: parentRental.id,
      imageSource: parentRental.deviceDefinition?.imageURL,
      link: generateLink({
        employeeId,
        isOrganisation,
        organisationId,
        rentalId: parentRental.id,
      }),
      title: parentRental.deviceDefinition?.name || '',
    },
  ]
}
